import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store/store'

interface storeIDState {
  storeID: string
}

const initialState: storeIDState = {
  storeID: null,
}

// Slice
const storeIDSlice = createSlice({
  name: 'storeID',
  initialState,
  reducers: {
    setStoreID: (state, action: PayloadAction<string>) => {
      const { payload } = action
      state.storeID = payload
    },
  },
})

// Selectors
export const getStoreIDSelector = (state: RootState): string =>
  state?.sagaStore.storeID

// Actions
export const { setStoreID } = storeIDSlice.actions

// Reducers
export default storeIDSlice.reducer
